export const AI_PROVIDER_TYPES = {
    AZURE: 'azure',
    AWS: 'aws',
    KIMI: 'kimi',
    OPENAI: 'openai',
    X: 'x',
    GOOGLE: 'google',
    DEEPSEEK: 'deepseek',
    INCOGNITO: 'incognito',
};
